export const HELPER_CLASS = 'drag-helper'
